__turbopack_context__.v({
  "description": "sIc3Pq_description",
  "info": "sIc3Pq_info",
  "modal": "sIc3Pq_modal",
  "modalPaper": "sIc3Pq_modalPaper",
  "skeleton": "sIc3Pq_skeleton",
});
